import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import TraderListTable from '../../component/table/TableComponents/TraderListTable';
import styled from 'styled-components';
import Sidebar from '../../Sidebar/Sidebar';
import Header from '../../component/header/Header';
import { HeaderButtonProvider } from '../../component/header/HeaderButtonProvider';
import OrderListTable from '../../component/table/OrderListTable';
import OrderListPage from '../../pages/OrderListPage';
import Table from '../../component/table/Table';

import axios from 'axios';
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { Children, useEffect, useRef, useState } from 'react';
import { RootState } from '../../store/modules';
import { useSelector } from 'react-redux';
import { getAccessTokenAsync } from '../../service/tokenService';
import DashBoardPage from '../../pages/DashBoardPage';
import { ProductionAdd } from './pages/ProductionAdd';
import { useDispatch } from 'react-redux';
import {
  addStockHistoryData,
  addUnsyncedStockHistoryData,
  increaseProductionCount,
  setProductionData,
  setStockData,
  setStockHistoryData,
  setUnsyncedStockHistoryData,
  updateProductionData,
  updateStockHistoryData,
  updateUnsyncedStockHistoryData,
} from '../../store/modules/socketData';
import { ProductionProgress } from './pages/ProductionProgress';
import { WebsocketManager } from '../../hook/WebsocketManager';
import { Stock } from './pages/Stock';
import NaverMap from '../../component/map/NaverMap';
import { NaverMapWrapper } from '../../component/map/NaverMapWrapper';
import { ProductionProgressWorker } from './pages/ProductionProgressWorker';
import { ProductionInbound } from './pages/ProductionInbound';
import { BomPage } from './pages/BomPage';
import { ParcelItemPage } from './pages/ParcelItemPage';
import { ParcelTraderPage } from './pages/ParcelTraderPage';
import { ParcelPage } from './pages/ParcelPage';
import { Attendance } from './pages/Attendance';
import { OrderAddressVerifyTable } from '../../component/table/TableComponents/OrderAddressVerifyTable';
import { EmmShopOrderTable } from '../../component/table/TableComponents/EmmShopOrderTable';
import { OrderAddressModifyTable } from '../../component/table/TableComponents/OrderAddressModifyTable';
import toast, { ToastOptions } from 'react-hot-toast';
import { OrderUpdatePage } from './pages/OrderUpdatePage';
import { ProductionOverview } from './pages/ProductionOverview';
import { BsArrowUpCircleFill } from 'react-icons/bs';
import { OrderTable } from '../../component/table/TableComponents/OrderTable';
import { DeliveryEditPage } from './pages/DeliveryEditPage';
import { DeliveryListPage } from './pages/DeliveryListPage';
import { TraderAbbreviationPage } from './pages/TraderAbbreviationPage';
import { ItemAbbreviationPage } from './pages/ItemAbbreviationPage';
import { Custombar } from '../../Sidebar/Custombar';
import { ChartAnalysisPage } from './pages/ChartAnalysisPage';
import { TableAnalysisPage } from './pages/TableAnalysisPage';
import { PotentialCustomerTable } from '../../component/table/TableComponents/PotentialCustomerTable';
import { useWebsocket } from '../../hook/WebsocketContext';
import { Inquiries } from '../../component/popup/Inquiries';
import { InquiriesModal } from '../../component/common/modal/InquiriesModal';
import { setOpen } from '../../store/modules/inquiriesState';
import useFetch from '../../api/useFetch';
import { userListGetApi } from '../../api/apiConfig';
import { addNewItem } from '../../store/modules/inquiriesItem';
import { Machine } from './pages/Machine';
import { MachineAssignment } from './pages/MachineAssignment';
import { StockHistoryLog } from './pages/StockHistoryLog';

export const ManagerRouter = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLoginId =
    useSelector((state: RootState) => state.loginUserData?.loginId) || null;

  // const { subscribe, connectSocket, isConnected } = useWebsocket();
  // useEffect(() => {
  //   connectSocket();
  // }, []);

  // useEffect(() => {
  //   if (isConnected) {
  //     subscribe('production', (data) => {
  //       if (data.type === 'CREATED') {
  //         dispatch(setProductionData(data.data));
  //       } else if (data.type === 'INCREASED') {
  //         dispatch(increaseProductionCount(data.data));
  //       } else if (data.type === 'UPDATED') {
  //         dispatch(updateProductionData(data.data));
  //       }
  //     });
  //     subscribe('stock', (data) => {
  //       if (data.type === 'UPDATED') {
  //         dispatch(setStockData(data.data));
  //       }
  //     });
  //     subscribe('stock-history', (data) => {
  //       if (data.type === 'CREATED') {
  //         dispatch(setStockHistoryData(data.data));
  //       }
  //       if (data.type === 'UPDATED') {
  //         dispatch(updateStockHistoryData(data.data));
  //       }
  //       if (data.type === 'ADDED') {
  //         dispatch(addStockHistoryData(data.data));
  //       }
  //     });
  //     subscribe('unsynced-stock-history', (data) => {
  //       if (data.type === 'CREATED') {
  //         dispatch(setUnsyncedStockHistoryData(data.data));
  //       }
  //       if (data.type === 'UPDATED') {
  //         dispatch(updateUnsyncedStockHistoryData(data.data));
  //       }
  //       if (data.type === 'ADDED') {
  //         dispatch(addUnsyncedStockHistoryData(data.data));
  //       }
  //     });
  //     if (userLoginId !== null) {
  //       console.log(`🔗 구독 시도: /sub/chat/${userLoginId}`);
  //       subscribe(`/sub/chat/${userLoginId}`, (message) => {
  //         console.log(`📩 새 메시지 (ID: ${userLoginId}):`, message);
  //         dispatch(addNewItem(message));
  //       });
  //     }
  //   }
  // }, [isConnected, userLoginId]);

  useEffect(() => {
    if (location.pathname === '/' || location.pathname === '/login') {
      navigate('/dash-board');
      // navigate('/orders');
    }
  }, [location]);

  const WithDefaultLayout = ({
    children,
    hideHeader = false,
  }: {
    children: React.ReactNode;
    hideHeader?: boolean;
  }) => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 200); // 200px 이상 스크롤됐는지 판단
      };

      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    const handleScrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
      <HeaderButtonProvider>
        <Sidebar />
        <BodyContainer>
          {!hideHeader && <Header />}

          <Content>{children}</Content>
          {isScrolled && (
            <div
              style={{
                position: 'fixed',
                right: '20px',
                bottom: '20px',
                cursor: 'pointer',
              }}
              onClick={() => handleScrollToTop()}
            >
              <BsArrowUpCircleFill size={40} />
            </div>
          )}
        </BodyContainer>
        <Custombar />
      </HeaderButtonProvider>
    );
  };
  return (
    <WholeContainer>
      <WebsocketManager />

      <Routes>
        <Route
          path='/dash-board'
          element={
            <WithDefaultLayout hideHeader>
              <DashBoardPage />
            </WithDefaultLayout>
          }
        />

        <Route
          path='/trader/update'
          element={
            <WithDefaultLayout>
              <TraderListTable />
            </WithDefaultLayout>
          }
        />
        <Route
          path='trader/abbreviation'
          element={
            <WithDefaultLayout>
              <TraderAbbreviationPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='item/abbreviation'
          element={
            <WithDefaultLayout>
              <ItemAbbreviationPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='production-add'
          element={
            <WithDefaultLayout>
              <ProductionAdd />
            </WithDefaultLayout>
          }
        />
        <Route
          path='production-overview'
          element={
            <WithDefaultLayout>
              <ProductionOverview />
            </WithDefaultLayout>
          }
        />
        <Route
          path='production-progress'
          element={
            <WithDefaultLayout>
              <ProductionProgress />
            </WithDefaultLayout>
          }
        />
        <Route
          path='production-inbound'
          element={
            <WithDefaultLayout>
              <ProductionInbound />
            </WithDefaultLayout>
          }
        />
        <Route
          path='production-progress/:productionId/:itemId'
          element={
            // <WithDefaultLayout>
            <ProductionProgressWorker />
            // </WithDefaultLayout>
          }
        />
        <Route
          path='stock'
          element={
            <WithDefaultLayout>
              <Stock />
            </WithDefaultLayout>
          }
        />
        {/* <Route path='/' element={<OrderListPage />} /> */}
        {/* <Route path='/' element={<Table />} /> */}
        {/* <Route path='/' element={<OrderlistPage />} /> */}
        <Route
          path='orders'
          element={
            <WithDefaultLayout>
              <OrderTable />
            </WithDefaultLayout>
          }
        />
        <Route
          path='/orders/update'
          element={
            <WithDefaultLayout>
              <OrderUpdatePage />
            </WithDefaultLayout>
          }
        />
        {/* 현재 미사용 */}
        <Route
          path='orders/address-verify'
          element={
            <WithDefaultLayout>
              <OrderAddressVerifyTable />
            </WithDefaultLayout>
          }
        />
        <Route
          path='orders/address-modify'
          element={
            <WithDefaultLayout>
              <OrderAddressModifyTable />
            </WithDefaultLayout>
          }
        />
        <Route
          path='orders/emm-shop-changed'
          element={
            <WithDefaultLayout>
              <EmmShopOrderTable />
            </WithDefaultLayout>
          }
        />
        <Route
          path='order-list'
          element={
            <WithDefaultLayout>
              <OrderListPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='delivery/set'
          element={
            <WithDefaultLayout>
              <DeliveryEditPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='delivery/list'
          element={
            <WithDefaultLayout>
              <DeliveryListPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='bom'
          element={
            <WithDefaultLayout>
              <BomPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='parcel-item'
          element={
            <WithDefaultLayout>
              <ParcelItemPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='parcel-trader'
          element={
            <WithDefaultLayout>
              <ParcelTraderPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='parcel'
          element={
            <WithDefaultLayout>
              <ParcelPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='attendance'
          element={
            <WithDefaultLayout>
              <Attendance />
            </WithDefaultLayout>
          }
        />
        <Route
          path='analysis/chart'
          element={
            <WithDefaultLayout>
              <ChartAnalysisPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='analysis/order-statistics'
          element={
            <WithDefaultLayout>
              <TableAnalysisPage />
            </WithDefaultLayout>
          }
        />
        <Route
          path='analysis/potential-customer-orders'
          element={
            <WithDefaultLayout>
              <PotentialCustomerTable />
            </WithDefaultLayout>
          }
        />
        <Route
          path='machine'
          element={
            <WithDefaultLayout>
              <Machine />
            </WithDefaultLayout>
          }
        />
        <Route
          path='machine-assignment'
          element={
            <WithDefaultLayout>
              <MachineAssignment />
            </WithDefaultLayout>
          }
        />
        <Route
          path='stock-history-log'
          element={
            <WithDefaultLayout>
              <StockHistoryLog />
            </WithDefaultLayout>
          }
        />
        <Route path='naver-map' element={<NaverMapWrapper />} />
        {/* <Route
          path='inquiries'
          element={
            <WithDefaultLayout>
              <Inquiries />
            </WithDefaultLayout>
          }
        /> */}
      </Routes>
    </WholeContainer>
  );
};

const WholeContainer = styled.div`
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: row;
  position: relative;
`;

const BodyContainer = styled.div`
  flex-basis: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Content = styled.div`
  flex: 1;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.lightGray};
`;
